exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-1cf55a3b]:export {\n  xrColorPrimary: #2362FB;\n}\n.popover-footer[data-v-1cf55a3b] {\n  background-color: #f7f8fa;\n  padding: 0 10px;\n  height: 40px;\n  line-height: 40px;\n  border-top: 1px solid #e6e6e6;\n}\n.popover-footer .el-button[data-v-1cf55a3b] {\n    float: right;\n    margin-top: 6px;\n    padding: 6px 12px;\n}\n.popover-footer .el-button + .el-button[data-v-1cf55a3b] {\n    margin-left: 0;\n    margin-right: 10px;\n}\n", ""]);

// exports
